/**
 * The 5-tab tenant IA (DESIGN.md §5). Routes themselves are unchanged —
 * tabs are navigation presentation only. Everything not under the four
 * primary tabs lives under More.
 */
export type TenantTab = 'today' | 'schedule' | 'customers' | 'vehicles' | 'more'

export const TENANT_TABS: { key: TenantTab; to: string }[] = [
  { key: 'today', to: '/' },
  { key: 'schedule', to: '/appointments' },
  { key: 'customers', to: '/customers' },
  { key: 'vehicles', to: '/vehicles' },
  { key: 'more', to: '/more' },
]

const MORE_PREFIXES = [
  '/more',
  '/estimates',
  '/calls',
  '/dealers',
  '/suppliers',
  '/messaging',
  '/threads',
  '/settings',
]

export function tabForPathname(pathname: string): TenantTab | null {
  if (pathname === '/' || pathname.startsWith('/dashboard')) return 'today'
  if (pathname.startsWith('/appointments')) return 'schedule'
  if (pathname.startsWith('/customers')) return 'customers'
  if (pathname.startsWith('/vehicles')) return 'vehicles'
  if (MORE_PREFIXES.some((p) => pathname.startsWith(p))) return 'more'
  // Off-IA routes (e.g. /sandbox/*) light no tab rather than lying.
  return null
}
